import { Link } from 'react-router-dom';
import { Sparkles } from 'lucide-react';
import { usePlanLimits } from '@/hooks/usePlanLimits';

// Dashboard banner shown while an account is on Trial Premium (KAN-136).
export default function TrialBanner() {
  const { trial } = usePlanLimits();
  if (!trial?.isActive) return null;

  const days = trial.daysRemaining;
  const label = typeof days !== 'number'
    ? 'Trial Premium'
    : days === 1 ? 'Trial Premium: 1 day remaining' : `Trial Premium: ${days} days remaining`;

  return (
    <div
      className="mb-6 p-3 bg-indigo-50 border border-indigo-200 rounded-lg flex flex-col sm:flex-row sm:items-center gap-3"
      data-testid="trial-dashboard-banner"
    >
      <Sparkles className="h-5 w-5 text-indigo-600 flex-shrink-0" />
      <p className="text-sm text-indigo-800 flex-1">
        <span className="font-medium">{label}.</span> You have full access to every feature.
      </p>
      <Link
        to="/employer/billing"
        className="text-sm font-medium text-indigo-700 underline underline-offset-2"
        data-testid="trial-dashboard-banner-cta"
      >
        Choose your plan
      </Link>
    </div>
  );
}
